import { useParams, Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import { useConsent } from "../consent/ConsentContext";
import { consentText } from "../consent/translations";
import { legalPath } from "../text/legal";

const CookieBanner = () => {
  const { bannerOpen, acceptAll, acceptNecessary } = useConsent();
  const { lang } = useParams();
  const language = lang === "ru" || lang === "en" ? lang : "ro";
  const t = consentText[language];

  if (!bannerOpen) return null;

  return (
    <div
      id="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 px-3 pb-3 md:px-6 md:pb-6 pointer-events-none"
      role="region"
      aria-label={t.title}
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-2xl bg-white shadow-xl border border-[#e5f2f2] px-5 py-4 md:px-8 md:py-5 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex items-start gap-3 md:items-center">
          <Cookie className="shrink-0 mt-1 md:mt-0" color="#26CAD3" size={26} />
          <div>
            <h2 className="font-[satoshi,'Manrope'] font-bold text-base text-[#003E47]">
              {t.title}
            </h2>
            <p className="font-[satoshi,'Manrope'] text-sm text-muted-foreground mt-1">
              {t.body}{" "}
              <Link
                to={legalPath(language, "cookies")}
                className="underline text-[#003E47] hover:text-[#26CAD3] whitespace-nowrap"
              >
                {t.details}
              </Link>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 md:ml-auto shrink-0">
          <Button
            variant="outline"
            onClick={acceptNecessary}
            className="border-[#26CAD3] text-[#003E47] hover:bg-[#eef9f9] hover:text-[#003E47] bg-white"
          >
            {t.necessary}
          </Button>
          <Button
            onClick={acceptAll}
            className="bg-[#003E47] hover:bg-[#004f5a] text-white"
          >
            {t.accept}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
